export const authorType = [
  "author",

  {
    id: 1,
    name: "Musique",
    rightBase: 10000,
  },
  {
    id: 2,
    name: "Dramatique",
    rightBase: 10000,
  },
  {
    id: 3,
    name: "littéraire",
    rightBase: 10000,
  },
  {
    id: 4,
    name: "cinéma, scénariste",
    rightBase: 10000,
  },
  {
    id: 5,
    name: "Editeur",
    rightBase: 30000,
  },
];

export const bureau = [
  {
    id: 1,
    name: "Bamako",
  },
  {
    id: 2,
    name: "Kayes",
  },
  {
    id: 3,
    name: "Koulikoro",
  },
  {
    id: 4,
    name: "Segou",
  },
  {
    id: 5,
    name: "Sikasso",
  },
  {
    id: 6,
    name: "Mopti",
  },
  {
    id: 7,
    name: "Gao",
  },
  {
    id: 8,
    name: "Tombouctou",
  },
  {
    id: 9,
    name: "Kidal",
  },
  {
    id: 10,
    name: "Taoudeni",
  },
  {
    id: 11,
    name: "Ménaka",
  },
];

export const redevableType = [
  "redevable",

  {
    id: 1,
    name: "Dramatique",
    rightBase: 10000,
    lyricsBase: null,
    crPercentBase: null,
    rightPercent: 10,
    crPercent: 1,
    lyricsPercent: null,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 2,
    name: "Dramatique 2Actes Minim. Lyrique partie Musicale de 30 mn Maximum",
    rightBase: 8000,
    lyricsBase: 3000,
    crPercentBase: null,
    lPercent: 8,
    crPercent: 0.5,
    lyricsPercent: 3,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 3,
    name: "Dramatique 2 Actes Minim. Lyrique partie Musicale de 1H 30 mn Maximum",
    rightBase: 5000,
    lyricsBase: 6000,
    crPercentBase: null,
    rightPercent: 6,
    crPercent: 0.4,
    lyricsPercent: 5,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 4,
    name: "Dramatique  Acte seul. Lyrique : partie musicale complétant le spectacle",
    rightBase: 4000,
    lyricsBase: 7000,
    crPercentBase: null,
    rightPercent: 4,
    crPercent: 0.4,
    lyricsPercent: 7,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 5,
    name: "Dramatique  1 Acte seul. Lyrique : partie musicale complétant le spectacle",
    rightBase: 3000,
    lyricsBase: 9000,
    crPercentBase: null,
    rightPercent: 2,
    crPercent: 0.2,
    lyricsPercent: 8,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 6,
    name: "Concert, Variétés  (Exclusivement)",
    rightBase: 10000,
    lyricsBase: null,
    crPercentBase: null,
    rightPercent: 9,
    crPercent: 1,
    lyricsPercent: null,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 7,
    name: "Concert, Variétés + Sketches",
    rightBase: 7000,
    lyricsBase: 3000,
    crPercentBase: null,
    rightPercent: 2,
    crPercent: 1,
    lyricsPercent: 8,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 8,
    name: "Film",
    rightBase: 5000,
    lyricsBase: 3000,
    crPercentBase: null,
    rightPercent: 2,
    crPercent: 1,
    lyricsPercent: 4,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 9,
    name: "pectacles Vendus 11% sur le P.A",
    rightBase: null,
    lyricsBase: null,
    crPercentBase: null,
    rightPercent: null,
    crPercent: null,
    lyricsPercent: null,
    type: "Seances Occasionnelles",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
  {
    id: 10,
    name: "Tarification Reproduction Mécanique",
    tour: 45,
    other: null,
    rightBase: 1500,
    type: "Reproduction Mécanique",
    nbMin: 20,
    nbMed: 50,
    nbMax: 100,
  },
];

export const fieldsPerson = [
  {
    fieldId: "nom",
    name: "Nom",
    type: "text",
    placeholder: "Traoré, Cissé",
    category: "identity",
  },
  {
    fieldId: "prenom",
    name: "Prénom",
    type: "text",
    placeholder: "Aminata, Brahima",
    category: "identity",
  },

  {
    fieldId: "date_naissance",
    name: "Date de naissance",
    type: "date",
    placeholder: "01-01-1970",
    category: "date",
  },
  {
    fieldId: "pays",
    name: "Pays",
    type: "text",
    placeholder: "Mali",
    category: "adresse",
  },
  {
    fieldId: "ville",
    name: "Ville",
    type: "text",
    placeholder: "Bamako, Segou",
    category: "adresse",
  },
  {
    fieldId: "region",
    name: "region",
    type: "text",
    placeholder: "Koulikoro, Sikasso",
    category: "adresse",
  },
  {
    fieldId: "adresse",
    name: "adresse",
    type: "text",
    placeholder: "Lafibougou, Faladie",
    category: "adresse",
  },
  {
    fieldId: "cin",
    name: "Piece d'identité",
    type: "file",
    placeholder: "Près du marché, fouroufourou carré",
    category: "file",
  },
  {
    fieldId: "acte",
    name: "Acte de naissance",
    type: "file",
    placeholder: "Près du marché, fouroufourou carré",
    category: "file",
  },
  {
    fieldId: "attestation",
    name: "Attestation de diffusion",
    type: "file",
    placeholder: "Près du marché, fouroufourou carré",
    category: "file",
  },
  {
    fieldId: "oeuvre",
    name: "Copie de l'oeuvre",
    type: "file",
    placeholder: "Près du marché, fouroufourou carré",
    category: "file",
  },
  {
    fieldId: "contrat_edition",
    name: "Contrat d'edition",
    type: "file",
    placeholder: "Près du marché, fouroufourou carré",
    category: "file",
  },
];

export const fieldsMoral = [
  {
    fieldId: "name",
    name: "Raison social",
    type: "text",
    placeholder: "Africable, Byblos",
    category: "identity",
  },
  {
    fieldId: "nif",
    name: "Numero d'identification Fiscale",
    type: "text",
    placeholder: "NIF",
    category: "identity",
  },

  {
    fieldId: "nina",
    name: "NINA",
    type: "text",
    placeholder: "NINA",
    category: "identity",
  },
  {
    fieldId: "rccm",
    name: "RCCM",
    type: "text",
    placeholder: "Registre de commerce",
    category: "identity",
  },

  {
    fieldId: "nb",
    name: "Nombre",
    type: "text",
    placeholder: "50",
    category: "identity",
  },
  {
    fieldId: "date",
    name: "Date de creation",
    type: "date",
    placeholder: "01-01-1970",
    category: "date",
  },
  {
    fieldId: "representative",
    name: "Représenter par",
    type: "text",
    placeholder: "Registre de commerce",
    category: "identity",
  },

  {
    fieldId: "pays",
    name: "Pays",
    type: "text",
    placeholder: "Mali",
    category: "adresse",
  },
  {
    fieldId: "ville",
    name: "Ville",
    type: "text",
    placeholder: "Bamako, Segou",
    category: "adresse",
  },
  {
    fieldId: "region",
    name: "Region",
    type: "text",
    placeholder: "Koulikoro, Sikasso",
    category: "adresse",
  },
  {
    fieldId: "quartier",
    name: "Quartier",
    type: "text",
    placeholder: "Lafibougou, Faladie",
    category: "adresse",
  },
  {
    fieldId: "adresse_details",
    name: "Precision Quartier",
    type: "textarea",
    placeholder: "Près du marché, fouroufourou carré",
    category: "adresse",
  },
];

export const changePassword = [
  {
    field_id: "code",
    name: "Code",
    type: "text",
    placeholder: "Code recu par email",
    category: "identity",
  },
  {
    field_id: "password",
    name: "Nouveau mot de passe",
    type: "password",
    placeholder: "Nouveau mot de passe",
    category: "identity",
  },
  {
    field_id: "passwordConfirmation",
    name: "Confirmer le mot de passe",
    type: "password",
    placeholder: "Confirmer le mot de passe",
    category: "identity",
  },
];

export const resetFields = [
  {
    id: 1,
    attributes: {
      field_id: "email",
      name: "Email",
      type: "email",
      placeholder: "Email",
      category: "identity",
    },
  },
];

//  export const authorFiedls =  [
//   {
//     fieldId: 'nom',
//     name: 'Nom',
//     type: 'textarea',
//     placeholder: 'Nom',
//     category:'identity'
//   },
//   {
//     fieldId: 'prenom',
//     name: 'Prenom',
//     type: 'textarea',
//     placeholder: 'Prenom',
//     category:'identity'
//   },
//   {
//     fieldId: 'date',
//     name: 'Date de naissance',
//     type: 'textarea',
//     placeholder: 'Nom',
//     category:'identity'
//   },
//   {
//     fieldId: 'nom',
//     name: 'Nom',
//     type: 'textarea',
//     placeholder: 'Nom',
//     category:'identity'
//   },
// ]
